import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { EncriptacionService } from 'src/app/services/encriptacion.service';
import { GeneralService } from 'src/app/services/general.service';
import { UsuarioService } from 'src/app/services/usuario.service';
import { BeneficiaryService } from '../../../services/beneficiary.service';

@Component({
  selector: 'app-busca-user',
  templateUrl: './busca-user.component.html',
  styleUrls: ['./busca-user.component.css']
})
export class BuscaUserComponent implements OnInit {

  constructor(
    private fb: FormBuilder,
    public _general: GeneralService,
    private usuarioService: UsuarioService,
    private beneficiaryService: BeneficiaryService
  ) {}

  usuario: any;
  rutCuenta: string;
  busquedaRealizada = false;

  plansList: any[] = [];
  planesAgrupados: any[] = [];

  rutABuscar = this.fb.group({
    rutBbdd: ['']
  });

  ngOnInit(): void {
    if (!sessionStorage.getItem('token')) {
      this.usuarioService.logout();
    }

    this.usuario = new EncriptacionService().getUserInfo();
    this.rutCuenta = this.usuario.rut;
  }

  changeRut(): void {
    const valor: any = this.rutABuscar.value.rutBbdd;
    if (!valor) { return; }

    const limpio = valor.replace(/\./g, '').replace(/-/g, '');
    if (limpio.length < 2) { return; }

    const cuerpo = limpio.slice(0, -1);
    const dv = limpio.slice(-1).toUpperCase();

    this.rutABuscar.patchValue(
      { rutBbdd: `${cuerpo}-${dv}` },
      { emitEvent: false }
    );
  }

  buscarRut(): void {
    const rut = this.rutABuscar.value.rutBbdd;

    this.busquedaRealizada = true;
    this.plansList = [];
    this.planesAgrupados = [];

    if (!this._general.validaRut(rut)) {
      this._general.modalError('El usuario buscado no existe en el sistema', 'Ingresar RUT válido');
      this.rutABuscar.reset();
      return;
    }

    this.beneficiaryService.searchBeneficiary({ rut })
      .then((data: any) => {
        this.plansList = Array.isArray(data) ? data : [];

        if (this.plansList.length > 0) {
          this.agruparPlanesPorPoliza();
        }

        this.rutABuscar.reset();
      })
      .catch(() => {
        this.plansList = [];
        this.planesAgrupados = [];
        this._general.modalError('Ocurrió un error al buscar la información del usuario', '');
      });
  }

 agruparPlanesPorPoliza(): void {
  const grupos = new Map<string, any[]>();

  this.plansList.forEach((plan: any) => {
    const key = plan.poliza || 'SIN_POLIZA';

    if (!grupos.has(key)) {
      grupos.set(key, []);
    }

    grupos.get(key)?.push(plan);
  });

  this.planesAgrupados = Array.from(grupos.entries()).map(([poliza, items]) => {
    const ordenados = [...items].sort((a, b) => {
      const fechaTerminoA = new Date(a.fecha_termino || 0).getTime();
      const fechaTerminoB = new Date(b.fecha_termino || 0).getTime();

      if (fechaTerminoB !== fechaTerminoA) {
        return fechaTerminoB - fechaTerminoA;
      }

      const fechaInicioA = new Date(a.fecha_inicio || 0).getTime();
      const fechaInicioB = new Date(b.fecha_inicio || 0).getTime();

      return fechaInicioB - fechaInicioA;
    });

    return {
      poliza,
      planActual: ordenados[0],
      historial: ordenados.slice(1),
      expanded: false
    };
  });

  this.planesAgrupados.sort((a, b) => {
    const fechaA = new Date(a.planActual?.fecha_termino || 0).getTime();
    const fechaB = new Date(b.planActual?.fecha_termino || 0).getTime();
    return fechaB - fechaA;
  });
}

  toggleHistorial(grupo: any): void {
    grupo.expanded = !grupo.expanded;
  }

  tieneHistorial(grupo: any): boolean {
    return Array.isArray(grupo?.historial) && grupo.historial.length > 0;
  }

  trackByGrupo(index: number, item: any): string {
    return item.key;
  }

  trackByHistorial(index: number, item: any): string {
    return `${item.poliza}_${item.folio || index}_${item.fecha_inicio || ''}`;
  }
}